import { render, staticRenderFns } from "./Game.vue?vue&type=template&id=b9b1fe1a&scoped=true"
import script from "./Game.vue?vue&type=script&lang=ts"
export * from "./Game.vue?vue&type=script&lang=ts"
import style0 from "./Game.vue?vue&type=style&index=0&id=b9b1fe1a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9b1fe1a",
  null
  
)

export default component.exports